<dx-popup
  (onHidden)="this.onHidden()"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [resizeEnabled]="!this.shortView"
  [shading]="false"
  [showTitle]="true"
  [visible]="this.visible"
  (onResizeEnd)="this.onResizeEnd($event)"
  (onResize)="this.onResize($event)"
  [height]="this.height"
  [width]="this.width"
  title="Hedge Matrix Columns"
  id="hedge-matrix-column-selector"
  titleTemplate="title"
>
  <div *dxTemplate="let data of 'title'" style="background: black; padding: 5px 10px">
    <div class="window-title">
      <div class="title-with-toggle">
        <span>Hedge Matrix Columns</span>
        <span class="es-hedging-toggle" *ngIf="this.cmp && !this.shortView && this.cmp.isEsEligible">
          <span class="label">ES Hedging</span>
          <dx-switch [value]="this.cmp.esHedgingEnabled"
                     (onValueChanged)="this.onEsHedgingModeChanged($event)">
          </dx-switch>
        </span>
      </div>
      <div class="icons">
        <span class="expand-collapse icon">
          <i class="fas fa-compress-arrows-alt" *ngIf="!this.shortView" (click)="this.shrinkWindow()"></i>
          <i class="fas fa-expand-arrows-alt" *ngIf="shortView" (click)="this.expandWindow()"></i>
        </span>
        <span class="close icon">
          <i class="fas fa-times fa-lg" (click)="this.closeWindow()"></i>
        </span>
      </div>
    </div>
  </div>


  <div *dxTemplate="let data of 'content'">
    <div class="root">

      <!-- Shared Templates -->

      <!-- Hedge Tpl -->
      <ng-template #hedgeTpl let-hedge>
        <div class="hedge-item">
          <div class="name">
            <div class="checkbox">
              <dx-check-box (onValueChanged)="this.onHedgeSelectionChanged($event, hedge)"
                            [value]="this.isHedgeSelected(hedge)">
              </dx-check-box>
            </div>
            <div class="label">
              {{ hedge.label }} :: {{ hedge.expirationsString }}, {{ hedge.dayOfWeeksString }}
            </div>
          </div>
          <div class="modification-toggle">
            <div>Mods</div>
            <div>
              <dx-check-box
                [value]="!hedge.turnOffModifications"
                (onValueChanged)="this.onToggleModifications(hedge, $event.value)"
              ></dx-check-box>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Expiration Tpl -->
      <ng-template #expirationTpl let-expiration>
        <div class="expiration-item">
          <div class="checkbox">
            <dx-check-box (onValueChanged)="this.onExpirationSelectionChanged($event, expiration)"
                          [value]="this.isExpirationSelected(expiration)">
            </dx-check-box>
          </div>
          <div class="label">
            {{ expiration.dayOfWeekShort }}, {{ expiration.expirationFull }}
          </div>
        </div>
      </ng-template>

      <!-- P&L Expiration Tpl -->
      <ng-template #pnlExpirationTpl let-expiration>
        <div class="expiration-item">
          <div class="checkbox">
            <dx-check-box
              (onValueChanged)="this.onPnlExpirationSelectionChanged($event, expiration, false)"
              [value]="this.isPnlExpirationSelected(expiration, false)">
            </dx-check-box>
          </div>
          <div class="label">
            {{ expiration.dayOfWeekShort }} {{ expiration.expirationFull }}
          </div>
          <div class="toggle">
            <div class="label">
              Show "All" Column
            </div>
            <div class="input">
              <dx-switch
                (onValueChanged)="this.onPnlExpirationSelectionChanged($event, expiration, true)"
                [value]="this.isPnlExpirationSelected(expiration, true)"
              ></dx-switch>
            </div>
          </div>
        </div>
      </ng-template>

      <dx-scroll-view>
        <div class="container">

          <!-- ═══════════ SPX UNIT ═══════════ -->
          <div class="unit spx" *ngIf="this.isSpxUnitVisible()">

            <div class="unit-header">
              <span *ngIf="!this.shortView || !this.hasNonBaseUnderlyings">SPX</span>
              <dx-select-box *ngIf="this.shortView && this.hasNonBaseUnderlyings"
                [items]="this.shortViewUnderlyingOptions"
                displayExpr="label"
                valueExpr="value"
                [(value)]="this.shortViewUnderlying"
                [width]="85"
                [inputAttr]="{ style: 'text-align: center' }"
              ></dx-select-box>
            </div>

            <div class="unit-content">
            <!-- SPX Pricings -->
            <div class="side left" *ngIf="this.isCompactPricingVisible()">

              <div class="header">
                <span>Pricings</span>
                <span *ngIf="this.shortView" class="icon" (click)="this.switchColumn()" title="Switch to Total P&L"><i class="fas fa-arrows-alt-h"></i></span>
              </div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSelectAllHedges($event)"
                              [value]="this.allHedgesSelected"
                              text="Select All Hedges">
                </dx-check-box>
              </div>

              <div class="section day-toggles">
                <div class="toggle" *ngFor="let exp of this.uniqueExpirations; trackBy: this.trackByExpiration">
                  <dx-check-box [text]="exp.expirationFull + ', ' + exp.dayOfWeek"
                    [value]="this.isDayToggleSelected(exp)"
                    (onValueChanged)="this.onDayToggleSelectionChanged(exp, $event)"
                  ></dx-check-box>
                </div>
              </div>

              <div class="section hedge">
                <div class="title">Call Hedges</div>
                <div class="selector">
                  <ng-container *ngFor="let group of this.callHedgesByExpiration; trackBy: this.trackByGroup">
                    <fieldset class="group">
                      <legend class="group-header">
                        <dx-check-box [text]="group.expiration.expirationFriendly + ', ' + group.expiration.dayOfWeek"
                          [value]="this.getHedgeGroupSelectionState(group)"
                          (onValueChanged)="this.onHedgeGroupSelectionChanged(group, $event)"
                        ></dx-check-box>
                      </legend>
                      <ng-container *ngFor="let cHedge of group.hedges; trackBy: this.trackByHedge">
                        <ng-container *ngTemplateOutlet="hedgeTpl; context: {$implicit: cHedge}"></ng-container>
                      </ng-container>
                    </fieldset>
                  </ng-container>
                </div>
              </div>

              <div class="section hedge">
                <div class="title">Put Hedges</div>
                <div class="selector">
                  <ng-container *ngFor="let group of this.putHedgesByExpiration; trackBy: this.trackByGroup">
                    <fieldset class="group">
                      <legend class="group-header">
                        <dx-check-box [text]="group.expiration.expirationFriendly + ', ' + group.expiration.dayOfWeek"
                          [value]="this.getHedgeGroupSelectionState(group)"
                          (onValueChanged)="this.onHedgeGroupSelectionChanged(group, $event)"
                        ></dx-check-box>
                      </legend>
                      <ng-container *ngFor="let cHedge of group.hedges; trackBy: this.trackByHedge">
                        <ng-container *ngTemplateOutlet="hedgeTpl; context: {$implicit: cHedge}"></ng-container>
                      </ng-container>
                    </fieldset>
                  </ng-container>
                </div>
              </div>

              <div class="row"><hr></div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSelectAllExpirations($event)"
                              [value]="this.allExpirationsSelected"
                              text="Select All Expirations">
                </dx-check-box>
              </div>

              <div class="section expiration">
                <div class="title">Call Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.callExpirationList; trackBy: this.trackByExpiration">
                    <ng-container *ngTemplateOutlet="expirationTpl; context: {$implicit: item}"></ng-container>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration">
                <div class="title">Put Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.putExpirationList; trackBy: this.trackByExpiration">
                    <ng-container *ngTemplateOutlet="expirationTpl; context: {$implicit: item}"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- SPX Total P&L -->
            <div class="side right" *ngIf="this.isCompactPnlVisible()">

              <div class="header">
                <span>Total P&L</span>
                <span *ngIf="this.shortView" class="icon" (click)="this.switchColumn()" title="Switch to Pricings"><i class="fas fa-arrows-alt-h"></i></span>
              </div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSelectAllPnlExpirations($event)"
                              [value]="this.allPnlExpirationsSelected"
                              text="Select All Expirations">
                </dx-check-box>
              </div>

              <div class="section expiration">
                <div class="title">Call Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.callPnlExpirationList; trackBy: this.trackByExpiration">
                    <ng-container *ngTemplateOutlet="pnlExpirationTpl; context: {$implicit: item}"></ng-container>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration">
                <div class="title">Put Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.putPnlExpirationList; trackBy: this.trackByExpiration">
                    <ng-container *ngTemplateOutlet="pnlExpirationTpl; context: {$implicit: item}"></ng-container>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration grand">
                <div class="title">Grand Totals</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.expirationList; trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box
                          (onValueChanged)="this.onGrandTotalExpirationSelectionChanged($event, item)"
                          [value]="this.isGrandTotalExpirationSelected(item)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort}} {{ item.expirationFull }} {{ item.dte}}
                      </div>
                      <div class="checkbox normalized">
                        <dx-check-box
                          text="Normalized"
                          [value]="this.isNormalizedExpirationPnlEnabled(item)"
                          (onValueChanged)="this.onNormalizedExpirationPnlToggled($event, item)"
                        ></dx-check-box>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

            </div>
            </div><!-- /unit-content -->
          </div>

          <!-- ═══════════ ES UNITS (one per underlying) ═══════════ -->
          <ng-container *ngFor="let section of this.visibleEsSections; trackBy: this.trackBySection">
          <div class="unit es" [class.compact]="this.shortView">

            <div class="unit-header">
              <span *ngIf="!this.shortView">{{ section.displayName }}</span>
              <dx-select-box *ngIf="this.shortView"
                [items]="this.shortViewUnderlyingOptions"
                displayExpr="label"
                valueExpr="value"
                [(value)]="this.shortViewUnderlying"
                [width]="85"
                [inputAttr]="{ style: 'text-align: center' }"
              ></dx-select-box>
            </div>

            <div class="unit-content">
            <!-- ES Pricings -->
            <div class="side left" *ngIf="this.isCompactPricingVisible()">

              <div class="header">
                <span>Pricings</span>
                <span *ngIf="this.shortView" class="icon" (click)="this.switchColumn()" title="Switch to Total P&L"><i class="fas fa-arrows-alt-h"></i></span>
              </div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSectionAllHedges($event, section)"
                              [value]="this.isSectionAllHedgesSelected(section)"
                              text="Select All Hedges">
                </dx-check-box>
              </div>

              <div class="section day-toggles">
                <div class="toggle" *ngFor="let exp of this.getSectionUniqueExpirations(section); trackBy: this.trackByExpiration">
                  <dx-check-box [text]="exp.expirationFull + ', ' + exp.dayOfWeek"
                    [value]="this.isSectionDayToggleSelected(exp, section)"
                    (onValueChanged)="this.onSectionDayToggleSelectionChanged(exp, $event, section)"
                  ></dx-check-box>
                </div>
              </div>

              <div class="section hedge">
                <div class="title">Call Hedges</div>
                <div class="selector">
                  <ng-container *ngFor="let group of this.getSectionHedgesByExpiration(section, 'Call'); trackBy: this.trackByGroup">
                    <fieldset class="group">
                      <legend class="group-header">
                        <dx-check-box [text]="group.expiration.expirationFriendly + ', ' + group.expiration.dayOfWeek"
                          [value]="this.getHedgeGroupSelectionState(group)"
                          (onValueChanged)="this.onHedgeGroupSelectionChanged(group, $event)"
                        ></dx-check-box>
                      </legend>
                      <ng-container *ngFor="let cHedge of group.hedges; trackBy: this.trackByHedge">
                        <ng-container *ngTemplateOutlet="hedgeTpl; context: {$implicit: cHedge}"></ng-container>
                      </ng-container>
                    </fieldset>
                  </ng-container>
                </div>
              </div>

              <div class="section hedge">
                <div class="title">Put Hedges</div>
                <div class="selector">
                  <ng-container *ngFor="let group of this.getSectionHedgesByExpiration(section, 'Put'); trackBy: this.trackByGroup">
                    <fieldset class="group">
                      <legend class="group-header">
                        <dx-check-box [text]="group.expiration.expirationFriendly + ', ' + group.expiration.dayOfWeek"
                          [value]="this.getHedgeGroupSelectionState(group)"
                          (onValueChanged)="this.onHedgeGroupSelectionChanged(group, $event)"
                        ></dx-check-box>
                      </legend>
                      <ng-container *ngFor="let cHedge of group.hedges; trackBy: this.trackByHedge">
                        <ng-container *ngTemplateOutlet="hedgeTpl; context: {$implicit: cHedge}"></ng-container>
                      </ng-container>
                    </fieldset>
                  </ng-container>
                </div>
              </div>

              <div class="row"><hr></div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSectionAllExpirations($event, section)"
                              [value]="this.isSectionAllExpirationsSelected(section)"
                              text="Select All Expirations">
                </dx-check-box>
              </div>

              <div class="section expiration">
                <div class="title">Call Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.getSectionCallExpirationList(section); trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box (onValueChanged)="this.onSectionExpirationSelectionChanged($event, item, section)"
                                      [value]="this.isSectionExpirationSelected(item, section)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort }}, {{ item.expirationFull }}
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration">
                <div class="title">Put Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.getSectionPutExpirationList(section); trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box (onValueChanged)="this.onSectionExpirationSelectionChanged($event, item, section)"
                                      [value]="this.isSectionExpirationSelected(item, section)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort }}, {{ item.expirationFull }}
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- ES Total P&L -->
            <div class="side right" *ngIf="this.isCompactPnlVisible()">

              <div class="header">
                <span>Total P&L</span>
                <span *ngIf="this.shortView" class="icon" (click)="this.switchColumn()" title="Switch to Pricings"><i class="fas fa-arrows-alt-h"></i></span>
              </div>

              <div class="section">
                <dx-check-box (onValueChanged)="this.toggleSectionAllPnlExpirations($event, section)"
                              [value]="this.isSectionAllPnlExpirationsSelected(section)"
                              text="Select All Expirations">
                </dx-check-box>
              </div>

              <div class="section expiration">
                <div class="title">Call Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.getSectionCallPnlExpirationList(section); trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box
                          (onValueChanged)="this.onSectionPnlExpirationSelectionChanged($event, item, false, section)"
                          [value]="this.isSectionPnlExpirationSelected(item, false, section)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort }} {{ item.expirationFriendly }}
                      </div>
                      <div class="toggle">
                        <div class="label">Show "All" Column</div>
                        <div class="input">
                          <dx-switch
                            (onValueChanged)="this.onSectionPnlExpirationSelectionChanged($event, item, true, section)"
                            [value]="this.isSectionPnlExpirationSelected(item, true, section)"
                          ></dx-switch>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration">
                <div class="title">Put Expirations</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.getSectionPutPnlExpirationList(section); trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box
                          (onValueChanged)="this.onSectionPnlExpirationSelectionChanged($event, item, false, section)"
                          [value]="this.isSectionPnlExpirationSelected(item, false, section)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort }} {{ item.expirationFriendly }}
                      </div>
                      <div class="toggle">
                        <div class="label">Show "All" Column</div>
                        <div class="input">
                          <dx-switch
                            (onValueChanged)="this.onSectionPnlExpirationSelectionChanged($event, item, true, section)"
                            [value]="this.isSectionPnlExpirationSelected(item, true, section)"
                          ></dx-switch>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="section expiration grand">
                <div class="title">Grand Totals</div>
                <div class="selector">
                  <ng-container *ngFor="let item of this.getSectionExpirationList(section); trackBy: this.trackByExpiration">
                    <div class="expiration-item">
                      <div class="checkbox">
                        <dx-check-box
                          (onValueChanged)="this.onSectionGrandTotalExpirationSelectionChanged($event, item, section)"
                          [value]="this.isSectionGrandTotalExpirationSelected(item, section)">
                        </dx-check-box>
                      </div>
                      <div class="label">
                        {{ item.dayOfWeekShort}} {{ item.expirationFull }}
                      </div>
                      <div class="checkbox normalized">
                        <dx-check-box
                          text="Normalized"
                          [value]="this.isSectionNormalizedExpirationPnlEnabled(item)"
                          (onValueChanged)="this.onSectionNormalizedExpirationPnlToggled($event, item)"
                        ></dx-check-box>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

            </div>
            </div><!-- /unit-content -->
          </div>
          </ng-container>

        </div>
      </dx-scroll-view>
    </div>
  </div>

</dx-popup>
